/**
 * 1NOW-11896: Bonzah issues a policy's PDF at purchase and never again, so
 * after a date change the PDF shows other dates than the cover has. The
 * booking API's `bonzah_cover` lists each bought policy's cover as it stands,
 * beside the dates its PDF shows. These are the sentences the booking page
 * puts under the insurance documents: one per policy whose dates changed.
 */
export type BonzahCover = {
  policy_id?: string | null;
  policy_no?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  pdf_start_date?: string | null;
  pdf_end_date?: string | null;
  dates_changed?: boolean;
  endorsement_no?: string | null;
};

export const bonzahCoverNotes = (covers?: BonzahCover[] | null): string[] =>
  (covers ?? [])
    .filter((cover) => cover?.dates_changed)
    .map(
      (cover) =>
        `The insurance PDF shows the cover dates at purchase (${cover.pdf_start_date} – ${cover.pdf_end_date}). ` +
        `Current cover: ${cover.start_date} – ${cover.end_date}` +
        (cover.endorsement_no ? ` (endorsement ${cover.endorsement_no})` : "") +
        ".",
    );
